module.exports = __webpack_public_path__ + "img/@tmp_myclass_player_thumbnail_pdf.96f198b4.png";